import React, { useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";
import jwt from "jwt-decode";

function safeDecodeAuth() {
  const token = localStorage.getItem("auth");
  if (!token) return null;
  try {
    return jwt(token);
  } catch {
    return null;
  }
}

/**
 * Renders children only for admin users.
 * Non-admin users are redirected to the home page.
 */
export default function AdminOnly({ children }) {
  const location = useLocation();
  const decoded = useMemo(() => safeDecodeAuth(), []);
  const isAdmin = String(decoded?.contactType || "").toLowerCase() === "admin";

  if (!isAdmin) {
    return <Navigate to="/" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}

